"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _platform = require("../../../helpers/platform");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ImageUploadInput(_ref) {
  var onFileSelected = _ref.onFileSelected,
    clickImageCTA = _ref.clickImageCTA,
    isImageUploadEnabled = _ref.isImageUploadEnabled;
  var fileInput = /*#__PURE__*/_react["default"].createRef();

  // Desktop browser users can only select files from computer.
  // Mobile browser users can select file from phone
  // or take a picture from the camera and we cannot differentiate them.
  var imageOrigin = _platform.isMsite ? 'gallery/camera' : 'gallery';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ImageUploadContainer, {
    isImageUploadEnabled: isImageUploadEnabled,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: "image-upload-button"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ImageUploadButton, {
      id: "image-upload-button",
      type: "file",
      ref: fileInput,
      accept: "image/png, image/jpeg, image/gif, image/webp",
      onClick: function onClick() {
        return clickImageCTA(imageOrigin);
      },
      onChange: function onChange() {
        var file = fileInput.current.files[0];
        onFileSelected(file);
        fileInput.current.value = null;
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Camera, {
        color: "var(--color-secondary-100)"
      }),
      onClick: function onClick() {
        return fileInput.current.click();
      },
      hideVisibleLabel: true,
      label: "Enviar imagem"
    })]
  });
}
ImageUploadInput.propTypes = {
  onFileSelected: _propTypes.func.isRequired,
  clickImageCTA: _propTypes.func.isRequired,
  isImageUploadEnabled: _propTypes.bool
};
var _default = exports["default"] = ImageUploadInput;